import { useParams } from "react-router-dom";
import DefaultLayout from "@/layouts/default-layout";
import EditMeetsComp from "@/components/meets/edit-meets-comp";
import ViewMeetingDetailsComp from "@/components/v2/view-meeting-details-comp";
import ErrorBoundary from "@/components/error-boundries/error-boundry-comp";

const EditMeetingPage = () => {
  const { short_code } = useParams();
  return (
    <ErrorBoundary>
      <ViewMeetingDetailsComp _shortCode={short_code} />
    </ErrorBoundary>
  );
};

export default EditMeetingPage;
